module.exports = __webpack_public_path__ + "img/pc_text_bg.3e60f8c.png";